<template>
    <div>
      <trademark-objection-to-us-decision-list></trademark-objection-to-us-decision-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  